import {
  Button,
  IconButton,
  Typography,
  Alert,
  Snackbar,
  FormControl,
  CircularProgress,
  Backdrop,
  Grid,
  InputLabel,
  Box,
  ButtonGroup,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Dialog,
  FormHelperText,
  MenuItem,
  Select,
  styled
} from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import SubCard from 'ui-component/cards/SubCard';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { AddLanguage, BrandingBank, BrandingLanguage, BrandUpload } from 'API/Branding';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});
const UploadBranding = () => {
  const [photoFiles, setPhotoFiles] = useState([]);
  const [FileError, setFileErrors] = useState('');
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [Data, setData] = useState({
    bank: '',
    language: ''
  });
  const [BankList, setBankList] = useState('');
  const [open, setOpen] = React.useState(false);
  const [BrandLang, setBrandLang] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [Success, setSuccess] = useState(false);
  const [Error, setError] = useState(false);
  const [NewLang, setNewLang] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [Indexset, setIndexset] = useState(null);

  const photoInputRef = useRef();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSubmitLang = () => {
    if (!NewLang) {
      setError('Add a new language');
    } else {
      AddLanguage(NewLang, setIsLoading, setSuccess, setError, setOpen, refunction, setNewLang);
    }
  };

  const handleChange = (name, value) => {
    setData({ ...Data, [name]: value });
    setErrors((prev) => {
      const updated = { ...prev };
      if (value && updated[name]) {
        delete updated[name];
      }
      return updated;
    });
  };
  const validate = () => {
    let tempErrors = {};
    if (!Data.bank) tempErrors.bank = 'bank is required';
    if (!Data.language) tempErrors.language = 'language is required';

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z\s]/g, '');
  };
  const handleSuccess = () => {
    setData(
      {
        bank: '',
        language: ''
      },
      setPhotoFiles([])
    );
  };
  const handleSubmit = () => {
    if (validate()) {
      if (photoFiles.length === 0) {
        setFileErrors('Please upload a photo');
      } else {
        // Proceed with form submission
        BrandUpload(Data, photoFiles, setIsLoading, setSuccess, setError, handleSuccess);
      }
    }
  };
  const handleRemoveFile = (index) => {
    setConfirmDialog(true);
    setIndexset(index);
  };
  const handleUpdate = () => {
    setPhotoFiles((prev) => prev.filter((_, i) => i !== Indexset));
    setConfirmDialog(false);
  };
  const handlePreview = (file) => {
    setPreviewFile(file);
    setPreviewOpen(true);
  };
  const handleClosePreview = () => {
    setPreviewOpen(false);
    setPreviewFile(null);
  };
  const formattedName = (value) => {
    if (!value) return ''; // Handle null or undefined values

    // Convert to lowercase and capitalize the first letter of each word
    return value
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  const MAX_FILES = 10;
  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files);
    const validExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
    const maxSizeInMB = 2;
    const validatedFiles = [];

    for (let file of files) {
      const ext = file.name.split('.').pop().toLowerCase();
      const sizeInMB = file.size / (1024 * 1024); // Convert bytes to MB

      if (!validExtensions.includes(ext)) {
        setFileErrors('Only JPG, JPEG, PNG, and PDF files are allowed');
        photoInputRef.current.value = '';
        return; // stop further processing
      }
      if (photoFiles.length + files.length > MAX_FILES) {
        setFileErrors('You can only upload a maximum of 10 documents');
        photoInputRef.current.value = '';
        return;
      }

      if (sizeInMB > maxSizeInMB) {
        setFileErrors('File size should not exceed 2MB');
        photoInputRef.current.value = '';
        return; // stop further processing
      }

      validatedFiles.push(file);
    }

    // If all files are valid
    setFileErrors('');
    setPhotoFiles((prev) => [...prev, ...validatedFiles]);
    photoInputRef.current.value = '';
  };
  const refunction = () => {
    BrandingLanguage(setBrandLang);
  };
  useEffect(() => {
    BrandingLanguage(setBrandLang);
    BrandingBank(setBankList);
  }, []);
  return (
    <>
      <Dialog open={confirmDialog} maxWidth="xs" fullWidth>
        <DialogTitle></DialogTitle>
        <DialogContent>
          <Typography variant="h3">Are you sure you want to remove the file</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog(false)} color="secondary">
            No
          </Button>
          <Button onClick={handleUpdate} color="secondary" variant="contained">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Success}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
      >
        <Alert onClose={() => setSuccess(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={FileError || Error}
        autoHideDuration={5000}
        onClose={() => {
          setError(false);
          setFileErrors(false);
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => {
            setError(false);
            setFileErrors(false);
          }}
          variant="filled"
          severity="error"
          sx={{ width: '100%' }}
        >
          {FileError || Error}
        </Alert>
      </Snackbar>
      <Dialog open={previewOpen} onClose={handleClosePreview} maxWidth="md" fullWidth>
        <Box p={2}>
          <Typography variant="h6" mb={2}>
            File Preview
          </Typography>
          <IconButton aria-label="close" onClick={handleClosePreview} sx={{ position: 'absolute', top: 8, right: 8 }}>
            <CloseIcon />
          </IconButton>
          {previewFile && (
            <>
              {['pdf'].includes(previewFile.name.split('.').pop().toLowerCase()) ? (
                <iframe src={URL.createObjectURL(previewFile)} width="100%" height="600px" title="PDF Preview" style={{ border: 'none' }} />
              ) : (
                <img src={URL.createObjectURL(previewFile)} alt="Uploaded" style={{ maxWidth: '100%', maxHeight: '600px' }} />
              )}
            </>
          )}
        </Box>
      </Dialog>
      <SubCard title="Upload Branding">
        <Grid container spacing={2}>
          <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
            <FormControl fullWidth error={!!errors.bank}>
              {/* <TextField
                label="Select Bank"
                required
                value={Data.bank}
                onChange={(e) => handleChange('bank', e.target.value)}
                error={Boolean(errors.bank)}
                helperText={errors.bank}
              /> */}
              <InputLabel required id="demo-simple-select-label">
                Select Bank
              </InputLabel>
              <Select
                label="Select Bank"
                name="bank"
                value={Data.bank ? Data.bank : 'select'}
                onChange={(e) => handleChange('bank', e.target.value)}
                error={Boolean(errors.bank)}
                helperText={errors.bank}
              >
                <MenuItem value={'select'} disabled>
                  Select
                </MenuItem>
                {BankList &&
                  BankList.map((bank, index) => (
                    <MenuItem value={bank} key={index}>
                      {bank.name}
                    </MenuItem>
                  ))}
              </Select>
              {errors.bank && <FormHelperText>{errors.bank}</FormHelperText>}
            </FormControl>
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
            <FormControl fullWidth error={!!errors.language}>
              {/* <TextField
                label="Select Language"
                required
                value={Data.language}
                onChange={(e) => handleChange('language', e.target.value)}
                error={Boolean(errors.language)}
                helperText={errors.language}
              /> */}
              <InputLabel required id="demo-simple-select-label">
                Select Language
              </InputLabel>
              <Select
                label="Select Language"
                name="language"
                value={Data.language ? Data.language : 'select'}
                onChange={(e) => handleChange('language', e.target.value)}
                error={Boolean(errors.language)}
                helperText={errors.language}
              >
                <MenuItem value={'select'} disabled>
                  Select
                </MenuItem>
                {BrandLang && BrandLang.length > 0 ? (
                  BrandLang.map((lang, index) => (
                    <MenuItem value={formattedName(lang.language)} key={index}>
                      {formattedName(lang.language)}
                    </MenuItem>
                  ))
                ) : (
                  <Typography display={'flex'} justifyContent={'center'}>
                    No language data found
                  </Typography>
                )}
              </Select>
              {errors.language && <FormHelperText>{errors.language}</FormHelperText>}
            </FormControl>
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={6} xs={12} mt={1}>
            <Button
              variant="outlined"
              color="secondary"
              sx={{
                borderColor: '#592375',
                color: '#592375',
                borderRadius: '6px',
                '&:hover': {
                  borderColor: '#592375'
                }
              }}
              onClick={handleClickOpen}
            >
              Add Another
            </Button>
          </Grid>
          <Grid item xl={8} lg={8} md={8} sm={8} xs={12}>
            <Typography variant="h5" gutterBottom>
              Photo *
            </Typography>
            <Box border="1px solid #ccc" borderRadius={1} p={2}>
              {photoFiles.map((file, index) => {
                //   const url = URL.createObjectURL(file);
                return (
                  <Box key={index} display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="body2" flex={1}>
                      {file.name}
                    </Typography>
                    <Box display="flex" gap={1}>
                      <ButtonGroup>
                        <Button
                          size="small"
                          onClick={() => handlePreview(file)}
                          variant="contained"
                          sx={{ color: '#ffff', bgcolor: '#592375', borderColor: '#592375', '&:hover': { bgcolor: '#592375' } }}
                        >
                          View
                        </Button>
                        <Button
                          size="small"
                          // color="error"
                          onClick={() => handleRemoveFile(index)}
                          variant="outlined"
                          sx={{ color: '#592375', borderColor: '#592375', '&:hover': { borderColor: '#592375' } }}
                        >
                          <DeleteOutlineOutlinedIcon fontSize="small" sx={{ color: 'red' }} />
                        </Button>
                      </ButtonGroup>
                    </Box>
                  </Box>
                );
              })}

              <Button
                component="label"
                variant="outlined"
                sx={{
                  borderColor: '#592375',
                  color: '#592375',
                  borderRadius: '6px',
                  '&:hover': {
                    borderColor: '#592375'
                  }
                }}
                color="secondary"
              >
                Upload
                <VisuallyHiddenInput ref={photoInputRef} type="file" multiple onChange={handlePhotoUpload} />
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Box display={'flex'} justifyContent={'center'} mt={2}>
          <AnimateButton>
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#688B2A',
                color: '#FFFFFF',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: '#688B2A'
                }
              }}
              color="secondary"
              onClick={handleSubmit}
            >
              submit
            </Button>
          </AnimateButton>
        </Box>
      </SubCard>
      {/* add new language */}
      <Dialog open={open}>
        <DialogTitle variant="h5">Add new language</DialogTitle>
        <DialogContent>
          <IconButton
            aria-label="close"
            onClick={() => {
              setNewLang(null);
              setOpen(false);
            }}
            sx={{ position: 'absolute', top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContentText>
            To subscribe to this website, please enter your language here. We will send updates occasionally.
          </DialogContentText>
          <TextField
            required
            margin="dense"
            id="name"
            name="language"
            onInput={handleInput}
            value={NewLang}
            onChange={(e) => setNewLang(e.target.value)}
            placeholder="Enter your language"
            label="Language"
            type="text"
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          {/* <Button>Cancel</Button> */}
          <Button type="submit" onClick={handleSubmitLang}>
            submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UploadBranding;
